
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vitality",
      function () {
        return require("private-next-pages/vitality.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vitality"])
      });
    }
  